// src/droneFlyover.js - ЗАЦИКЛЕННЫЙ ПРОЛЕТ

class DroneFlyover {
  constructor(map) {
    this.map = map;
    this.isFlying = false;
    
    // 📹 ВИДЕО ЗАПИСЬ
    this.mediaRecorder = null;
    this.recordedChunks = [];
    this.isRecordingVideo = false;
    
    console.log('🚁 LOOPED DRONE INITIALIZED', map ? '✅ Map OK' : '❌ Map NULL');
  }

  // 🔍 ПРОВЕРКА КАРТЫ
  checkMap() {
    if (!this.map) {
      console.error('❌ Map is null');
      return false;
    }
    
    if (!this.map.getCanvas) {
      console.error('❌ Map.getCanvas is not available');
      return false;
    }
    
    if (!this.map.isStyleLoaded || !this.map.isStyleLoaded()) {
      console.error('❌ Map style not loaded');
      return false;
    }
    
    return true;
  }

  // 🔄 ЗАЦИКЛЕННЫЙ ПРОЛЕТ
  async startLoopedFlight() {
    if (this.isFlying) {
      console.log('🚁 Already flying, skipping');
      return;
    }
    
    if (!this.checkMap()) {
      console.error('❌ Cannot start flight - map not ready');
      return;
    }
    
    this.isFlying = true;
    console.log('🔄 STARTING LOOPED FLIGHT FOR SEAMLESS VIDEO');
    
    // 🎯 КООРДИНАТЫ
    const overviewLat = 40.710713;    // 📍 Точка обзора (начало/конец)
    const overviewLng = -73.968716;   // 📍 Точка обзора 
    const overviewZoom = 11.3;        // 🔥 Зум для обзора NYC
    
    const startLat = 40.704635;       // Начало пролета
    const startLng = -74.011369;
    const endLat = 40.868807;         // Конец пролета
    const endLng = -73.904114;
    
    const flyoverZoom = 14.5;         // Зум для пролета
    const flyoverPitch = 45;          // Наклон для пролета
    
    console.log(`🔄 Overview point: ${overviewLat},${overviewLng} @ zoom ${overviewZoom}`);
    console.log(`🚁 Flyover: ${startLat},${startLng} → ${endLat},${endLng} @ zoom ${flyoverZoom}`);
    
    try {
      // 🎬 ШАГ 1: НАЧАЛЬНАЯ ПОЗИЦИЯ ОБЗОРА (для зацикливания)
      console.log('🔄 Step 1: Setting overview position (start of loop)');
      this.map.jumpTo({
        center: [overviewLng, overviewLat],
        zoom: overviewZoom,
        pitch: 0,
        bearing: 0
      });
      
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // 🚁 ШАГ 2: ЗАЛЕТ К НАЧАЛУ ПРОЛЕТА
      console.log('🚁 Step 2: Flying to start position');
      return new Promise((resolve) => {
        this.map.flyTo({
          center: [startLng, startLat],
          zoom: flyoverZoom,
          pitch: flyoverPitch,
          bearing: 0,
          duration: 4000,        // 4 секунды залета
          essential: true
        });
        
        setTimeout(() => {
          // 🚁 ШАГ 3: ОСНОВНОЙ ПРОЛЕТ
          console.log('🚁 Step 3: Main flyover from south to north');
          
          this.map.flyTo({
            center: [endLng, endLat],
            zoom: flyoverZoom,
            pitch: flyoverPitch,
            bearing: 0,
            duration: 12000,     // 12 секунд основного пролета
            essential: true
          });
          
          setTimeout(() => {
            // 🔄 ШАГ 4: ВОЗВРАТ К ОБЗОРУ (для зацикливания)
            console.log('🔄 Step 4: Returning to overview (end of loop)');
            
            this.map.flyTo({
              center: [overviewLng, overviewLat],
              zoom: overviewZoom,
              pitch: 0,
              bearing: 0,
              duration: 4000,    // 4 секунды возврата
              essential: true
            });
            
            setTimeout(() => {
              this.isFlying = false;
              console.log('🔄 ✅ LOOPED FLIGHT COMPLETED - READY FOR SEAMLESS LOOP!');
              resolve();
            }, 4500);
            
          }, 12500);
          
        }, 4500);
      });
      
    } catch (error) {
      console.error('❌ Flight error:', error);
      this.isFlying = false;
    }
  }

  // 📹 ЗАПИСЬ
  async startRecording(quality = 'web') {
    if (!this.checkMap()) {
      console.error('❌ Cannot start recording - map not ready');
      return false;
    }
    
    try {
      console.log(`📹 Starting looped recording: ${quality}`);
      
      const bitrates = { mobile: 1000000, web: 3000000, hd: 6000000 };
      const bitrate = bitrates[quality] || bitrates.web;
      
      const canvas = this.map.getCanvas();
      if (!canvas) {
        console.error('❌ Cannot get canvas from map');
        return false;
      }
      
      const stream = canvas.captureStream(30);
      
      this.mediaRecorder = new MediaRecorder(stream, {
        mimeType: 'video/webm;codecs=vp8',
        videoBitsPerSecond: bitrate
      });
      
      this.recordedChunks = [];
      this.currentQuality = quality;
      
      this.mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          this.recordedChunks.push(event.data);
        }
      };
      
      this.mediaRecorder.onstop = () => {
        this.saveVideo();
      };
      
      this.mediaRecorder.start(1000);
      this.isRecordingVideo = true;
      
      console.log('✅ Looped recording started');
      return true;
      
    } catch (error) {
      console.error('❌ Recording error:', error);
      return false;
    }
  }

  // 💾 СОХРАНИТЬ
  saveVideo() {
    if (this.recordedChunks.length === 0) {
      console.warn('⚠️ No data to save');
      return;
    }

    const blob = new Blob(this.recordedChunks, { type: 'video/webm' });
    const sizeMB = (blob.size / (1024 * 1024)).toFixed(1);
    
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
    
    a.href = url;
    a.download = `looped-drone-nyc-${this.currentQuality}-${timestamp}.webm`;
    a.style.display = 'none';
    
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    console.log(`💾 Looped video saved: ${sizeMB} MB`);
    this.showNotification(`🔄 Looped NYC: ${sizeMB} MB`);
  }

  // 💾 УВЕДОМЛЕНИЕ
  showNotification(message) {
    const div = document.createElement('div');
    div.style.cssText = `
      position: fixed; top: 20px; left: 50%; transform: translateX(-50%);
      z-index: 20000; background: #34C759; color: white;
      padding: 15px 25px; border-radius: 10px; font-weight: bold;
    `;
    div.innerHTML = `💾 ${message}`;
    document.body.appendChild(div);
    setTimeout(() => div.remove(), 4000);
  }

  // 🙈 СКРЫТЬ UI
  hideUI() {
    const selectors = [
      '#tour-controls', '#flyover-controls', '#drone-controls',
      '.maplibregl-ctrl-top-left', '.maplibregl-ctrl-top-right',
      '.maplibregl-ctrl-bottom-left', '.maplibregl-ctrl-bottom-right',
      '.h3-controls', '.heatmap-controls'
    ];

    this.hiddenElements = [];
    
    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (el && el.style.display !== 'none') {
          this.hiddenElements.push({
            element: el,
            originalDisplay: el.style.display
          });
          el.style.display = 'none';
        }
      });
    });

    console.log(`🙈 Hidden ${this.hiddenElements.length} elements`);
  }

  // 👁️ ПОКАЗАТЬ UI
  showUI() {
    if (this.hiddenElements) {
      this.hiddenElements.forEach(({element, originalDisplay}) => {
        element.style.display = originalDisplay;
      });
      console.log(`👁️ Restored ${this.hiddenElements.length} elements`);
      this.hiddenElements = [];
    }
  }

  // ⏹️ ОСТАНОВИТЬ
  stop() {
    this.isFlying = false;
    
    if (this.isRecordingVideo) {
      this.mediaRecorder.stop();
      this.isRecordingVideo = false;
      console.log('⏹️ Recording stopped');
      setTimeout(() => this.showUI(), 1000);
    }
    
    console.log('⏹️ Looped flight stopped');
  }

  // 📱 МОБИЛЬНАЯ ЗАПИСЬ
  async recordMobile() {
    if (this.isFlying) {
      console.log('🚁 Already flying, cannot start mobile recording');
      return;
    }
    
    if (!this.checkMap()) {
      console.error('❌ Cannot start mobile recording - map not ready');
      return;
    }
    
    console.log('📱 Starting mobile looped recording...');
    
    this.hideUI();
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const started = await this.startRecording('mobile');
    if (!started) {
      this.showUI();
      return;
    }
    
    await this.startLoopedFlight();
    
    if (this.isRecordingVideo) {
      this.mediaRecorder.stop();
      this.isRecordingVideo = false;
    }
    
    setTimeout(() => this.showUI(), 1000);
  }

  // 🌐 ВЕБ ЗАПИСЬ
  async recordWeb() {
    if (this.isFlying) {
      console.log('🚁 Already flying, cannot start web recording');
      return;
    }
    
    if (!this.checkMap()) {
      console.error('❌ Cannot start web recording - map not ready');
      return;
    }
    
    console.log('🌐 Starting web looped recording...');
    
    this.hideUI();
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const started = await this.startRecording('web');
    if (!started) {
      this.showUI();
      return;
    }
    
    await this.startLoopedFlight();
    
    if (this.isRecordingVideo) {
      this.mediaRecorder.stop();
      this.isRecordingVideo = false;
    }
    
    setTimeout(() => this.showUI(), 1000);
  }
}

// 🎮 КОНТРОЛЛЕР
class DroneController {
  constructor(map) {
    this.drone = new DroneFlyover(map);
    this.createControls();
    this.setupKeys();
    console.log('🔄 Looped Drone Controller ready', map ? '✅ Map OK' : '❌ Map NULL');
  }

  setupKeys() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'F5') {
        event.preventDefault();
        this.drone.startLoopedFlight();
      }
      
      if (event.key === 'F7') {
        event.preventDefault();
        this.drone.recordWeb();
      }
      
      if (event.key === 'F8') {
        event.preventDefault();
        this.drone.recordMobile();
      }
      
      if (event.key === 'Escape') {
        this.drone.stop();
      }
    });
    
    console.log('⌨️ Looped Drone Keys:');
    console.log('   F5 - Looped Flight (zoomable)');
    console.log('   F7 - Web Looped Recording');
    console.log('   F8 - Mobile Looped Recording');
    console.log('   ESC - Stop');
  }

  createControls() {
    const existing = document.getElementById('drone-controls');
    if (existing) existing.remove();

    const div = document.createElement('div');
    div.id = 'drone-controls';
    div.style.cssText = `
      position: absolute; bottom: 80px; left: 50%; transform: translateX(-50%);
      z-index: 1000; background: rgba(255,149,0,0.9); padding: 15px;
      border-radius: 10px; display: flex; gap: 8px;
    `;
    
    div.innerHTML = `
      <button id="web-drone" style="background: #007AFF; color: white; border: none; padding: 8px 12px; border-radius: 5px; cursor: pointer; font-size: 11px;">
        🌐 WEB (F7)
      </button>
      <button id="mobile-drone" style="background: #34C759; color: white; border: none; padding: 8px 12px; border-radius: 5px; cursor: pointer; font-size: 11px;">
        📱 MOBILE (F8)
      </button>
      <button id="normal-drone" style="background: #8E8E93; color: white; border: none; padding: 8px 12px; border-radius: 5px; cursor: pointer; font-size: 11px;">
        🔄 LOOPED (F5)
      </button>
      <button id="stop-drone" style="background: #FF453A; color: white; border: none; padding: 8px 12px; border-radius: 5px; cursor: pointer; font-size: 11px;">
        ⏹️ STOP
      </button>
    `;
    
    document.body.appendChild(div);
    
    document.getElementById('web-drone').onclick = () => this.drone.recordWeb();
    document.getElementById('mobile-drone').onclick = () => this.drone.recordMobile();
    document.getElementById('normal-drone').onclick = () => this.drone.startLoopedFlight();
    document.getElementById('stop-drone').onclick = () => this.drone.stop();

    console.log('🎮 Looped drone controls created');
  }
}

export { DroneFlyover, DroneController };